<div (click)="clickOutside()">
<app-user-header></app-user-header>
<div class="container-wrapper">
    <router-outlet></router-outlet>
</div>
</div>

